import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { MetricKpiCard } from "@/features/dashboard/shell";
import { OverviewSection } from "@/features/dashboard/hub/OverviewSection";

import {
  MOCK_IMAGING_STUDIES_TODAY,
  MOCK_STUDIES_BY_CENTER,
  MOCK_STUDIES_BY_SPECIALTY,
} from "./mock-data";

const chartConfig = {
  count: { label: "Estudios", color: "var(--chart-2)" },
} satisfies ChartConfig;

/**
 * Overview mock de imagenología (hoy).
 */
export function ImagingOverview(): React.JSX.Element {
  return (
    <OverviewSection
      title="Imagenología"
      description="Estudios DICOM de hoy"
      isMock
    >
      <div className="mb-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
        <MetricKpiCard
          label="Estudios hoy"
          value={MOCK_IMAGING_STUDIES_TODAY}
          hint="Total de estudios del día (mock)"
        />
        {MOCK_STUDIES_BY_CENTER.slice(0, 3).map((c) => (
          <MetricKpiCard
            key={c.center}
            label={c.center}
            value={c.count}
            hint="Estudios por centro (mock)"
          />
        ))}
      </div>

      <p className="mb-2 text-sm font-medium text-muted-foreground">
        Estudios por especialidad (hoy)
      </p>
      <ChartContainer config={chartConfig} className="aspect-auto h-[180px] w-full">
        <BarChart
          data={MOCK_STUDIES_BY_SPECIALTY}
          margin={{ top: 4, right: 4, left: 0, bottom: 0 }}
        >
          <CartesianGrid vertical={false} strokeDasharray="3 3" className="stroke-border/50" />
          <XAxis dataKey="specialty" tickLine={false} axisLine={false} tick={{ fontSize: 11 }} />
          <YAxis tickLine={false} axisLine={false} width={28} allowDecimals={false} />
          <ChartTooltip content={<ChartTooltipContent />} />
          <Bar dataKey="count" fill="var(--color-count)" radius={[4, 4, 0, 0]} name="Estudios" />
        </BarChart>
      </ChartContainer>
    </OverviewSection>
  );
}
